
import environment from "../../../../environments/environment";
import { axiosInterceptor } from "../authInterceptor";
import creditLine from "../DummyJson/creditLine/creditLine.json";

export async function getCreditLineListDetails(vivo: any) {
    try {
        const response = await axiosInterceptor.post(`${environment.postCreditLinesList}`, vivo);
        return response;
    } catch (error: any) {
        return error;
    }
}

export async function getCreditBalByPid(participantId: number, clientId: number) {
    try {
        const getResponse = await axiosInterceptor.get(`${environment.creditBalanceByPid}/${participantId}?clientId=${clientId}`);
        return getResponse;
    } catch (error: any) {
        return error;
    }
}

export async function saveNewCreditLineDetails(vivo: any) {
    try {
        const response = await axiosInterceptor.post(`${environment.postNewCreditLine}`, vivo);
        return response;
    } catch (error: any) {
        return error;
    }
}

export async function getCreditLineDetails(CreditId: number, clientId: number) {
    try {
        const getResponse = await axiosInterceptor.get(`${environment.baseUrl}creditline/${CreditId}?clientId=${clientId}`);
        return getResponse;
    } catch (error: any) {
        return error;
    }
}
//   creditline/1
export async function putCreditLineDetails(creditId: number, vivo: any) {
    try {
        const response = await axiosInterceptor.patch(`${environment.postNewCreditLine}${creditId}`, vivo);
        return response;
    } catch (error: any) {
        return error;
    }
}

// creditline/payment
export async function postMakePayment(vivo: any) {
    try {
        const response = await axiosInterceptor.post(`${environment.saveCreditMakePayment}`, vivo);
        return response;
    } catch (error: any) {
        return error;
    }
}
export async function getCreditlineTransactionDate(CreditId: number, clientId: number) {
    try {
        const getResponse = await axiosInterceptor.get(`${environment.getDateForACreditlineTransaction}${CreditId}/posting-date-lower-bound?clientId=${clientId}`);
        return getResponse;
    } catch (error: any) {
        return error;
    }
}
export async function getCreditLinePandIAmountbyCreditId(CreditId: number, clientId: number, transactionDate?: string) {
    try {
        const getResponse = await axiosInterceptor.get(`${environment.getCreditLineAmountbyCreditId}/${CreditId}/summary?transactionDate=${transactionDate}&clientId=${clientId}`);
        return getResponse;
    } catch (error: any) {
        return error;
    }
}
export async function postCreditLinesMergertoloan(vivo: any) {
    try {
        const response = await axiosInterceptor.post(`${environment.postCreditLineClosureAndLoanMerge}`, vivo);
        return response;
    } catch (error: any) {
        return error;
    }
}